<template>
  <div>
    <el-popover placement="top-start" width="300" trigger="hover">
      <div class="spotCheckDetails" v-for="(item, index) in spotDetail" :key="index">
        <div class="row">
          <span>执行人：</span>{{ item.execute_by_admin.realname }}
        </div>
        <div class="row">
          <span>任务类型：</span>{{ item.type_name }}
        </div>
        <div class="row">
          <span>生成日期：</span>{{ item.created_at }}
        </div>
        <div class="row">
          <span>截止时间：</span>{{ item.end_at }}
        </div>
        <div class="row">
          <span>具体要求：</span> <span v-for="(desc, descIndex) in item.desc" :key="descIndex">({{ descIndex + 1 }}) {{ desc
            }},</span>
        </div>
      </div>
      <div class="spot" slot="reference">查</div>
    </el-popover>
  </div>
</template>
<script>
export default {
  props: {
    spotDetail: { type: Array }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.row {
  margin: 5px;

  .lable {
    margin-right: 10px;
  }
}

.spotCheckDetails {
  margin-bottom: 10px;

  &:nth-last-child(1) {
    margin: 0;
  }
}

.spot {
  background-color: #B4272D;
  color: #fff;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 10px auto 0;

}
</style>